import Vue from 'vue';

Vue.filter('versionActiva', function (versiones) {
  if (!versiones) return '';
  return versiones.filter(version => version.activa === true)
})
